/* Reuse Shopify-rendered cart state; serialize writes without delaying each click. */
(function () {
  'use strict';
  var BP = window.BarklyPaw = window.BarklyPaw || {};
  if (BP.cartState) return;
  var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
  var cached, seenNode, readAt = 0, dirty = false, locked = false, unconfirmed = false;
  var pendingRead, revision = 0, channel;

  function node() { return document.querySelector('cart-drawer [data-bp-cart-state]'); }
  function invalidate() {
    dirty = true;
    seenNode = node();
    revision++;
  }
  function read(force) {
    var current = node();
    if (!force && current && current !== seenNode) {
      try {
        var parsed = JSON.parse(current.textContent);
        if (!Array.isArray(parsed.items)) throw new Error('Missing cart items');
        cached = parsed; seenNode = current; readAt = Date.now(); dirty = false;
      } catch (e) { invalidate(); }
    }
    if (!force && !dirty && cached && Date.now() - readAt < 30000) return Promise.resolve(cached);
    if (pendingRead) return pendingRead;
    var startedAtRevision = revision;
    pendingRead = fetch(root + 'cart.js', {credentials:'same-origin', cache:'no-store', headers:{Accept:'application/json'}})
      .then(function (r) { if (!r.ok) throw new Error('Could not load your cart. Please try again.'); return r.json(); })
      .then(function (cart) {
        if (!Array.isArray(cart.items)) throw new Error('Could not confirm your cart.');
        if (startedAtRevision !== revision) throw new Error('Your cart changed. Please try again.');
        cached = cart; seenNode = node(); readAt = Date.now(); dirty = false;
        return cart;
      }).finally(function () { pendingRead = null; });
    return pendingRead;
  }
  function confirm() {
    unconfirmed = false;
    var drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.removeAttribute('data-bp-cart-unconfirmed');
  }
  function recover() {
    invalidate();
    return fetch(root + 'cart?sections=cart-drawer,cart-icon-bubble', {credentials:'same-origin', cache:'no-store', headers:{Accept:'text/html'}})
      .then(function (r) { if (!r.ok) throw new Error('Could not confirm your cart.'); return r.json(); })
      .then(function (sections) {
        if (typeof window.bpRenderCart !== 'function') throw new Error('Cart renderer unavailable');
        window.bpRenderCart({sections:sections});
        confirm();
      }).catch(function () {
        unconfirmed = true;
        var drawer = document.querySelector('cart-drawer');
        if (drawer) drawer.setAttribute('data-bp-cart-unconfirmed', 'true');
        throw new Error('We could not confirm the update. Please reload your cart before checkout.');
      });
  }
  BP.cartState = {
    read: read,
    invalidate: invalidate,
    recover: recover,
    confirm: confirm,
    begin: function () { if (locked || unconfirmed) return false; locked = true; return true; },
    end: function () { locked = false; if (channel) channel.postMessage('changed'); },
    isBusy: function () { return locked || unconfirmed; }
  };
  document.addEventListener('submit', function (event) {
    if ((locked || unconfirmed) && event.target.closest('cart-drawer, cart-items, #cart')) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('click', function (event) {
    if ((locked || unconfirmed) && event.target.closest('#CartDrawer-Checkout, #checkout')) {
      // 2026-10-28 (Ram: less friction): while a save runs, the drawer's CHECKOUT tap goes on to bp-cart-pelsbarn.js, which
      // queues it until the save is confirmed (or to the one-time offer, which waits the same way). Unconfirmed = still blocked.
      if (!unconfirmed && window.bpCartWhenIdle && event.target.closest('#CartDrawer-Checkout')) return;
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);
  window.addEventListener('focus', invalidate);
  window.addEventListener('pageshow', function (event) { if (event.persisted) invalidate(); });
  document.addEventListener('visibilitychange', function () { if (document.hidden) invalidate(); });
  document.addEventListener('cart:updated', invalidate);
  try {
    channel = new BroadcastChannel('barklypaw-cart');
    channel.onmessage = invalidate;
  } catch (e) {}
})();
